<template>
<v-row class="mt-7" >
<v-col col="12" >
<v-card max-width="auto" max-height="auto" >
  <v-carousel
      hide-delimiters
      show-arrows-on-hover cycle
      >
    <v-carousel-item
      v-for="(item,i) in slides"
      :key="i"
      :src="item.img"
    >
    <!-- <v-row
          class="fill-height"
          align="end"
          justify="space-around left"
        >
        <div class="d-block pa-2 display-3 grey darken-2">
          {{ item.slider }}
        </div>
    </v-row> -->
    </v-carousel-item>
  </v-carousel>
</v-card>
</v-col>
</v-row>
</template>

<script>
import axios from 'axios'
const BASE_URL = 'https://innuvex.com/'

export default {
  name: 'Home',

  data () {
    return {
      slides: []
    }
  },
  mounted () {
    // axios.get(BASE_URL + 'api/client/').then((response) => { console.log(response.data) })
    this.getSlider()
    console.log(this.getSlider())
    // console.log(this.getImageBlob())
  },
  methods: {
    getSlider () {
      var self = this
      axios({
        method: 'GET',
        url: BASE_URL + 'apiv1/slider/'
      }).then((response) => {
        self.slides = response.data.map((key) => {
          return {
            id: key.id,
            slider: key.slider_name,
            img: key.slider_image,
            active: key.active_slide
          }
        })
      }).catch((e) => {
        console.error(e)
      })
    }
  }
}
</script>
